import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import { AuthContext } from "../../App";
import Cookies from "universal-cookie";
import './Login.scss'
import { captureException } from '@sentry/browser';
import Button from "../Button/Button";
import GitHubIcon from '@mui/icons-material/GitHub';
import googleIcon from '../../images/googleIcon.svg';
import axiom from '../../images/axiom.png'
export default function Login() {

  const cookies = new Cookies();
  const { state, dispatch } = useContext(AuthContext);
  const [data, setData] = useState({ errorMessage: "", githubIsLoading: false , googleIsLoading: false });
  const { client_id, redirect_uri } = state;

  async function login_with_google (flag) {
    setData({ googleIsLoading: true });
    if(flag){
      cookies.set("google_login","true",{expires: new Date(Date.now() + 1000*1) , path:"/"});
    }
    
    var options = {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({}
      )

    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/google_login/" , options).then(response=>response.json())
    .then(async data=>{ 
      if (data.err){
        const event_id = captureException(data.err);
        console.log('error logged', { event_id }); 
      }
      const link = data.replace(/^"(.+)"$/,'$1');
      window.location.replace(link);
    });

}
  
  useEffect( async () => {
    if( window.location.href.includes("/google?code=")){
      const splitted = window.location.href.split("?code=");
      const splitted2=splitted[1].split("&")
      const google_code=splitted2[0]
      cookies.set("google_code",google_code,{ path:"/"});
      var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
          },
          body: JSON.stringify({
          "google_code": google_code
          })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+`/google/google_authenticate/` , options).then(response=>response.json())
      .then(async data=>{ 
        console.log("/google/google_authenticate/" , data);
        if(data.user_exist==null || ! data.user_exist){
          cookies.set("code","000000",{expires: new Date(Date.now() + 1000*60*60*7) , path:"/"});
          window.location.replace(process.env.REACT_APP_DOMAIN+"/releases");          
        }  
        else{
          cookies.set("google_login","true",{expires: new Date(Date.now() + 1000*1) , path:"/"});
          await login_with_github();
        }
      });
      
    }
    const url = window.location.href;
    const hasCode = url.includes("?code=");

    // If Github API returns the code parameter
    if (hasCode && ! url.includes("/google?code=") && cookies.get("code")==undefined) {
      const newUrl = url.split("?code=");
      window.history.pushState({}, null, newUrl[0]);

      const requestData = {
        code: newUrl[1]
      };
      state.code=newUrl[1];
      
      var options = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          requestData
        )

      };
      await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/authenticate/",options).then(response=>response.json())
      .then(async data=>{ 
        await login_with_google(false);
        if (data.err){
          const event_id = captureException(data.err);
          console.log('error logged', { event_id }); 
          setData({
            githubIsLoading: false,
            errorMessage: "Sorry! Login failed"
          });

        }  
        else {
          if(data.user_not_exist){
            cookies.set("login",data.data.user.login,{expires: new Date(Date.now() + 1000*60*60*7) , path:"/"})
            cookies.set("github_code",requestData.code,{expires: new Date(Date.now() + 1000*60*60*7) , path:"/"});
            cookies.set("name",data.name,{expires: new Date(Date.now() + 1000*60*60*7) , path:"/"})
            
          }
          else{
            dispatch({
              type: "LOGIN",
              payload: { user: data, isLoggedIn: true ,code: newUrl[1]}
            });
          }
          
        }
        
      })
      
    }
  }, [window.location.href]);


  if ( cookies.get("login")!=undefined && cookies.get("code")!=undefined && cookies.get("google_code")!=undefined) {
    console.log("login");
    cookies.remove("google_login");
    cookies.remove("github_login");
    window.location.replace(process.env.REACT_APP_DOMAIN+"/createEnv");
  }
  

  async function login_with_github(){
    if(cookies.get("github_login")==undefined){
      cookies.set("github_login","true",{expires: new Date(Date.now() + 1000*1) , path:"/"});
    }
    window.location.replace(`https://github.com/login/oauth/authorize?scope=user&client_id=${client_id}&redirect_uri=${redirect_uri}`)

  }

  return (
    <div className="login">
      <div className="card">
        <img src={axiom} className="axiom"></img>
        <div className="welcome">Welcome to Axiom</div>
        <div className="sub_title">From Workizers 💛 to Workizers</div>
        <span>{data.errorMessage}</span>
        <div className="login_buttons">
        <Button text="Login with GitHub and Google (Dev)" startIcon={<GitHubIcon/>} onClick={()=>login_with_github()} style={{"width": "341px", "margin-bottom" : "1em"}} loader={cookies.get("github_login")}/>
        <Button text="Login with Google" startIcon={<img src={googleIcon}/>} style={{"width": "341px"}} onClick={()=>login_with_google(true)} loader={cookies.get("google_login")}/>
        </div>
      </div>
      
    </div>
  );
}